import {Lang} from 'yougile-lang'

const BYTES_IN_MB = 1024 * 1024
const FILE_SIZE_LIMIT = 50 * BYTES_IN_MB
const CSV_EXTENSION = 'csv'

type Ret = {isValid: boolean; errorMessage?: string}

export const validateFile = (file: File): Ret => {
  if (!file?.name.toLowerCase().includes(CSV_EXTENSION)) {
    return {
      isValid: false,
      errorMessage: Lang.msg.importFromFile.unacceptableFileType
    }
  }

  if (file?.size > FILE_SIZE_LIMIT) {
    const errorMessage =
      Lang.msg.importFromFile.fileTooLarge +
      ` ${FILE_SIZE_LIMIT / BYTES_IN_MB} MB`
    return {isValid: false, errorMessage}
  }

  return {isValid: true}
}
